export default __webpack_public_path__ + "static/media/user_female.49f2eeab.svg";